import { EyeOutlined } from '@ant-design/icons';
import TcModal from 'components/UI/Modal/TcModal';
import { useState } from 'react';
import { MdBalance } from 'react-icons/md';

const NextDayTermsAndCondition = () => {
  //state
  // const [isChecked, setIsChecked] = useState<boolean>(false);
  const [showTermsAndCondition, setshowTermsAndCondition] = useState<boolean>(false);

  return (
    <>
      <TcModal title='قوانین و ضوابط ' onCancel={() => setshowTermsAndCondition(false)} footer={false} visible={showTermsAndCondition} width={800}>
        <div className='flex items-center py-3'>
          <MdBalance className='text-2xl ' />
          <span className='mx-1 text-sm font-medium'>کاربر گرامی لطفا قوانین و مقررات مربوط به سرویس روز بعد (NextDay) را به دقت مطالعه نمایید.</span>
        </div>
        <div className='overflow-auto h-[30rem] p-4 bg-t-layer-bg-color rounded-lg'>
          لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای
          شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را
          می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و
          دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد
          استفاده قرار گیرد. لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که
          لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان
          جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید
          داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی
          اساسا مورد استفاده قرار گیرد. لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و
          سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه
        </div>
        {/* <div className='flex justify-between pt-3 gap-x-2'>
          <div className='flex items-center gap-2'>
            <TcCheckbox checked={isChecked} onChange={(e) => setIsChecked(e.target.checked)} id='isCheckedTermsAndConditions' />
            <label className='text-sm select-none ' htmlFor='isCheckedTermsAndConditions'>
              شرایط و قوانین را مطالعه کرده و موافقم.
            </label>
          </div>
        </div> */}
      </TcModal>

      <div className='mt-1 text-xs text-t-secondary-text-color inherit-color'>
        <span
          className='ml-1 cursor-pointer hover:underline'
          onClick={(e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
            e.stopPropagation();
            setshowTermsAndCondition(true);
          }}>
          <EyeOutlined className='ml-1' />
          قوانین و مقررات{' '}
        </span>
        <span>را مطالعه کرده و موافقم.</span>
      </div>
    </>
  );
};

export default NextDayTermsAndCondition;
